import getResource from "../infrastructure/getResource";
import { MethodRequest } from "../interfaces/fetch/methodRequest";
import { IParametersFetch } from "../interfaces/fetch/parametersFetch";
import { ResponseResult } from "../interfaces/fetch/responseResult";
import { TypeReturn } from "../interfaces/fetch/typeReturn";
import { OrderingParametersForCreate } from "../interfaces/ordering/orderingParametersForCreate";
import { OrderingResult } from "../interfaces/ordering/orderingResult";
import { Account } from "../interfaces/ordering/payment/account";
import { CreatePaymentInternetAcquiringOnParameters } from "../interfaces/ordering/payment/createPaymentInternetAcquiringOnParameters";
import { ParametersForGetAccount } from "../interfaces/ordering/payment/parametersForGetAccount";
import { CreateOrderingOnSaleOrderCrmWithCreatePayResult } from "../interfaces/ordering/payment/result/createOrderingOnSaleOrderCrmWithCreatePayResult";
import { PaymentAccountForPartnersIdParam } from "../interfaces/ordering/paymentAccountForPartnersIdParam";
import { CreatePaymentLinkParameters } from "../interfaces/yandexPay/createPaymentLinkParameters";
import { RequestСreateOrderPaymentLinkResult } from "../interfaces/yandexPay/requestСreateOrderPaymentLinkResult";


/**
 * Создания платежа в интернет-эквайринге на основе параметров заказа
 * @param parameters - Параметры заказа на создания платежа
 * @returns 
 */
const createPaymentInternetAcquiringOnParametersOrdering = async (parameters: CreatePaymentInternetAcquiringOnParameters, url: string) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const parametersFetch: IParametersFetch<string> = {
    url: url,//config.ServiceOrdering.CreatePaymentInternetAcquiringOnParametersOrdering,
    methodRequest: MethodRequest.POST,
    body: JSON.stringify(parameters),
    typeReturn: TypeReturn.json,
    headers: headers,
  };

  const result: ResponseResult = await getResource(parametersFetch);
  return result.result as CreateOrderingOnSaleOrderCrmWithCreatePayResult;
};

/**
 * Получение р/с по параметрам
 * @param parametersForGetAccount - параметры для получения р/с
 * @returns 
 */
const getAccountsOnParameters = async (parametersForGetAccount: ParametersForGetAccount, url: string) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const parameters: IParametersFetch<string> = {
    url: url,//config.ServiceOrdering.GetAccountsOnParameters,
    methodRequest: MethodRequest.POST,
    body: JSON.stringify(parametersForGetAccount),
    typeReturn: TypeReturn.json,
    headers: headers,
  };

  const result: ResponseResult = await getResource(parameters);
  return result.result as Account[];
};

/**
 * Создание заказа версия 2
 * @param orderingParametersForCreate - параметры для создания заказа
 * @returns 
 */
const createOrderingV2 = async (orderingParametersForCreate: OrderingParametersForCreate, url: string) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const parameters: IParametersFetch<string> = {
    url: url,//config.ServiceOrdering.CreateOrderingV2,
    methodRequest: MethodRequest.POST,
    body: JSON.stringify(orderingParametersForCreate),
    typeReturn: TypeReturn.json,
    headers: headers,
  };

  const result: ResponseResult = await getResource(parameters);
  return result.result as OrderingResult;
};

/**
 * Обновление поля "время жизни заказа" заказа частичной оплаты
 * @param orderingId - Id child-заказа
 * @param url 
 * @returns 
 */
const updateOrderingPrePaymentLifeTime = async (orderingId: string, url: string) => {
  const parameters: IParametersFetch<string> = {
    url: `${url}/?orderingId=${orderingId}`, 
    methodRequest: MethodRequest.GET,
    body: null,
    typeReturn: TypeReturn.string,
  };

  const result: ResponseResult = await getResource(parameters);

  if (result.status === 200)
    return result.result as boolean;  
  
  return false;
};

/** Получить р/с по типу оплаты и типам прайс-листам */
const getPaymentAccountForPartnersId = async (paymentAccountForPartnersIdParam: PaymentAccountForPartnersIdParam, url: string) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const parameters: IParametersFetch<string> = {
    url: url,
    methodRequest: MethodRequest.POST,
    body: JSON.stringify(paymentAccountForPartnersIdParam),
    typeReturn: TypeReturn.string,
    headers: headers
  };

  const result = await getResource(parameters);

  return result.status === 200 ? result.result as string : null;
}

/**
* Создание заказа Яндекс Сплит
* @param createPaymentLinkParameters - Объект для создания заказа в Yandex Split
* @param url 
* @returns 
*/
const requestCreateOrderPaymentLink = async (createPaymentLinkParameters: CreatePaymentLinkParameters, url: string) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const parameters: IParametersFetch<string> = {
    url: url,
    methodRequest: MethodRequest.POST,
    body: JSON.stringify(createPaymentLinkParameters),
    typeReturn: TypeReturn.json,
    headers: headers
  };

  const result = await getResource(parameters);

  return result.result as RequestСreateOrderPaymentLinkResult;
};

export const PaymentService = {
  createPaymentInternetAcquiringOnParametersOrdering,
  getAccountsOnParameters,
  createOrderingV2,
  updateOrderingPrePaymentLifeTime,
  getPaymentAccountForPartnersId,
  requestCreateOrderPaymentLink
};